exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n    width: 100%;\n  }\n\n  /* table, th, td {\n    border: 1px solid black;\n} */\n\n  .table-data{\n  text-align: center;\n  font-size:13px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/dashboard/dashboardwidgets/dashboardwidgets.component.css
// module id = ../../../../../src/app/components/pages/dashboard/dashboardwidgets/dashboardwidgets.component.css
// module chunks = main